var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineEnclosedSurface20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1220",
    x: 2.5,
    y: 2.5,
    width: 15,
    height: 15,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 0V1.875H16.875V0H18.125V1.875H20V3.125H18.125V16.875H20V18.125H18.125V20H16.875V18.125H3.125V20H1.875L1.875 18.125H0V16.875H1.875L1.875 3.125H0V1.875H1.875L1.875 0H3.125ZM16.875 16.875V3.125H3.125L3.125 16.875H16.875Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1213",
    x: 15.625,
    y: 0.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630573",
    x: 15.625,
    y: 15.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630572",
    x: 0.625,
    y: 0.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630574",
    x: 0.625,
    y: 15.625,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineEnclosedSurface20);
export default __webpack_public_path__ + "static/media/line-enclosed-surface_20.8d74e828db877cf68015d4a1e82e3cc6.svg";
export { ForwardRef as ReactComponent };